<template>
  <b-modal id="logistic-proof-image-modal" centered header-class="border-bottom-0" hide-header hide-footer
    body-class="pt-4 px-0 text-center d-flex flex-column position-relative" @hidden="clearProofOfLogisticsData">
    <div id="logistics-modal-close" class="align-self-end position-absolute">
      <b-button variant="link" @click="closeModal">
        <img src="@/assets/images/close_v2.svg" alt="Close">
      </b-button>
    </div>
    <template v-if="!!proofOfLogisticsData">
      <img :src="proofOfLogisticsData.image" class="img-fluid mx-auto" alt="Proof Of Logistics">
      <p class="text-center mt-2">
        Uploaded on {{ formattedDateTime }}
      </p>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { DateTime } from "luxon";
import _ from "lodash";

export default {
  computed: {
    ...mapState("estore", {
      proofOfLogisticsData: state => state.proofOfLogisticsData
    }),
    formattedDateTime: {
      get() {
        const timestamp = _.get(this.proofOfLogisticsData, "timestamp", null)
        return timestamp ? DateTime.fromSQL(timestamp).toFormat("LLL d, y H:mm") : ""
      },
      set(timestamp) {
        return timestamp;
      }
    }
  },
  methods: {
    closeModal() {
      this.$root.$emit("bv::hide::modal", "logistic-proof-image-modal");
    },
    clearProofOfLogisticsData() {
      this.$store.state.estore.proofOfLogisticsData = {};
    }
  }
}
</script>

<style lang="scss">
#logistic-proof-image-modal {
  #logistics-modal-close {
    top: 10px;
    right: 5px;
  }

  .modal-body {
    img {
      max-width: 340px;
      max-height: 400px;
    }

    p {
      color: #2F3941;
      font-size: 16px;
    }
  }
}
</style>
